module.exports = __webpack_public_path__ + "static/media/sign_up_english.4c3b5a84.jpg";